'use client';

import { useRouter } from 'next/navigation';
import type { Session } from 'next-auth';
import { useEffect } from 'react';
import walletMessageChannel from '../message-channel/walletMessageChannel';
import walletStore from '../stores/walletStore';

type MessageChannelInitProps = {
  session: Session | null;
};

export const MessageChannelInit = ({ session }: MessageChannelInitProps) => {
  const { user, request } = walletStore();
  const { push } = useRouter();

  useEffect(() => {
    if (request) {
      push('/');
    }
  }, [request, push]);

  useEffect(() => {
    if (session?.user && !user) {
      walletStore.getState().setUser(session.user);
      walletMessageChannel.init();
    }
  }, [session, user]);

  return null;
};
